import api from './client';

// Wise API
export const wiseAPI = {
  getStatus: () => api.get('/integrations/wise/status'),
  sync: () => api.post('/integrations/wise/sync'),
  getBalances: () => api.get('/integrations/wise/balances'),
};
